import React from "react";
import {   Card,   Table,   } from "react-bootstrap";

// Komponen untuk menampilkan tabel
const UserTable = ({ data }) => {
  return (
    <Card.Body style={{ backgroundColor: "#fff", padding: "10px", borderRadius: "5px", lineHeight: "1.2" }}>
      <Table>
        <thead>
          <tr>
            <th>Provinsi</th>
            <th>Persentase</th>
          </tr>
        </thead>
        <tbody>
          {data.map((user) => (
            <tr>
              <td style={{ padding: "8px", fontFamily: "'Roboto','Helvetica Neue',Arial,sans-serif" }}>{user.nama_provinsi}</td>
              <td style={{ padding: "8px", fontFamily: "'Roboto','Helvetica Neue',Arial,sans-serif" }}>{user.total}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Card.Body>

    // <div style={{ backgroundColor: "#f0f0f0", padding: "10px", borderRadius: "5px", lineHeight: "1.5" }}>
    //   <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}>
    //     <thead>
    //       <tr style={{ background: "#e9d6d7", textAlign: "left" }}>
    //         <th style={{ padding: "8px" }}>Provinsi</th>
    //         <th style={{ padding: "8px" }}>Persentase</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {data.map((user) => (
    //         <tr key={user.id}>
    //           <td style={{ padding: "8px" }}>{user.nama_provinsi}</td>
    //           <td style={{ padding: "8px" }}>{user.total}</td>
    //         </tr>
    //       ))}
    //     </tbody>
    //   </table>
    // </div>
  );
};

export default UserTable;
